var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('st-filters-pagination',{ref:"filters",attrs:{"header":_vm.$t('CONTROL.LIST.TITLE'),"total":_vm.total,"stateModule":"control/list","filters":_vm.filters},on:{"change":_vm.doFilter}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }